import { MEMBERSHIP_PLAN_API } from '@/onenetwork/constants/onenetwork.api.constant.ts'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { defineStore } from 'pinia'

export enum MembershipPlanActionTypes {
  FETCHING = 'FETCHING',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_FAILURE = 'FETCH_FAILURE',
}

interface MembershipPlanState {
  action_type: MembershipPlanActionTypes | null,
  action_message: string | null,
  data: any[],
  filter: {
    page_size: number,
  },
}

export const memberShipPlanStore = defineStore('onenetwork.memberShipPlan', {
  state: (): MembershipPlanState => ({
    action_type: null,
    action_message: null,
    data: [],
    filter: {
      page_size: 0
    },
  }),
  persist: true,
  getters: {
    membershipPlan: (state) => state.data,
  },

  actions: {
    fetchMembershipPlan() {
      return new Promise(async (resolve, reject) => {
        try {
          this.action_type = MembershipPlanActionTypes.FETCHING
          const res = await APIClient.get(MEMBERSHIP_PLAN_API, { params: this.filter })

          this.data = res.data.data
          this.action_type = MembershipPlanActionTypes.FETCH_SUCCESS
          resolve(res.data)
        } catch (e) {

          this.action_type = MembershipPlanActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
